import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPatternBiasViolet({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 6 6"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <path fill="#DDE2EF" d="M0 0h6v6H0z" />
        <path
          fill="#8E9FCC"
          fillRule="nonzero"
          d="M-3.15 6.35l7-7L3.5-1l-7 7zm5 1l7-7L8.5 0l-7 7z"
        />
      </g>
    </svg>
  );
}

SvgPatternBiasViolet.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPatternBiasViolet.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPatternBiasViolet svgRef={ref} {...props} />
));
export default ForwardRef;
